import React from 'react';
import { useAuth } from '@clerk/react';
import { Navigate } from '../../routes';
import { useAppStore } from '../../store';
import { requiresOperatorClerkOrg } from '@repo/shared-types';
import { ROUTES } from '@repo/shared-types/routeRegistry';
import { LoadingSpinner } from '../ui/LoadingSpinner';

const isWebTest = import.meta.env.MODE === 'test';

/**
 * Suspends rendering until Clerk session + backend profile are ready, then redirects operators
 * without an active Clerk org to `/select-org`. Not used in Vitest (`test` mode) to avoid ClerkProvider.
 */
function OperatorOrgGateClerk({ children }: { children: React.ReactNode }) {
  const { isLoaded, orgId } = useAuth();
  const isAuthPending = useAppStore((s) => s.isAuthPending);
  const currentUserId = useAppStore((s) => s.currentUserId);
  const userRole = useAppStore((s) => s.userRole);
  const isSelfManagingOwner = useAppStore((s) => s.isSelfManagingOwner);

  if (!isLoaded || isAuthPending || !currentUserId?.trim()) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-900">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (requiresOperatorClerkOrg(userRole, isSelfManagingOwner === true) && !orgId) {
    return <Navigate to={ROUTES.SELECT_ORG} replace />;
  }

  return <>{children}</>;
}

export const OperatorOrgGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (isWebTest) return <>{children}</>;
  return <OperatorOrgGateClerk>{children}</OperatorOrgGateClerk>;
};
